import React from "react";

const ColumnsIcon = ({ className }) => (
  <svg
    className={className}
    width="1.5vw"
    viewBox="0 0 25 22"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"   // uses text color
    style={{ height: "auto" }}
  >
    <path d="M5.53941 0.00101461C6.6977 0.00101461 7.63668 0.958581 7.63668 2.1398V19.8612C7.63668 21.0424 6.6977 22 5.53941 22H2.54331C1.38502 22 0.446045 21.0424 0.446045 19.8612V2.1398C0.446045 1.01765 1.29347 0.0973335 2.3713 0.00810318L2.54331 0.00101461H5.53941ZM22.3488 0.00101461C23.5071 0.00101461 24.446 0.958581 24.446 2.1398V19.8612C24.446 21.0424 23.5071 22 22.3488 22H19.3527C18.1944 22 17.2554 21.0424 17.2554 19.8612V2.1398C17.2554 0.958581 18.1944 0.00101461 19.3527 0.00101461H22.3488ZM13.9284 0C15.0867 0 16.0257 0.957567 16.0257 2.13879V19.8602C16.0257 21.0415 15.0867 21.999 13.9284 21.999H10.9323C9.77409 21.999 8.83511 21.0415 8.83511 19.8602V2.13879C8.83511 0.957567 9.77409 0 10.9323 0H13.9284Z" />
  </svg>
);

export default ColumnsIcon;
